import { InjectionToken } from '@angular/core';
const MAT_INPUT_VALUE_ACCESSOR = /*#__PURE__*/new InjectionToken('MAT_INPUT_VALUE_ACCESSOR');
export { MAT_INPUT_VALUE_ACCESSOR };
